import React, { useContext, useEffect, useState } from "react";
import "../../styles/fonts.css";
import { Link } from "react-router-dom";
import favicon from "../../img/tuTrend.png";
import AuthContext from "../../context/auth/authContext";
import "./temp.css";
const Footer = () => {
  const authContext = useContext(AuthContext);
  const { currentUser, addComment } = authContext;
  const [comment, setComment] = useState({ email: "", text: "" });
  useEffect(() => {
    if (currentUser) {
      setComment({ ...comment, email: currentUser.email });
    }
  }, [currentUser]);

  const onChange = (e) => {
    setComment({ ...comment, [e.target.name]: e.target.value });
  };

  const onSend = (e) => {
    e.preventDefault();
    if (comment.email && comment.text) {
      addComment(comment);
    }

    if (currentUser) {
      setComment({ text: "", email: currentUser.email });
    } else {
      setComment({ email: "", text: "" });
    }
  };
  return (
    <footer className='footer-bs mb-0 bg-dark py-0'>
      <div className='row mb-0 '>
        <div className='col-md-4 footer-brand animated fadeInLeft'>
          <h1 className='mb-1'>
            <img
              src={favicon}
              width='70'
              height='70'
              className='d-inline-block align-top'
              alt=''
              loading='lazy'
            />
            <span className='mainfont size11 mx-1'>tuTrend</span>
          </h1>
          <p>
            Platform to clear your doubts and share legacies, knowledge,
            material ,information, makes and increase your acquaintace with
            professors, seniors, juniors, alumnis, industries and improve your
            skills.
          </p>
          <p> Since 2020 </p>
        </div>
        <div className='col-md-8 footer-ns animated fadeInRight'>
          <h4>Leave a comment</h4>
          <p>We will be happy to recieve reviews and comments!</p>

          <form>
            <div className='form-group row'>
              <label
                htmlFor='staticEmail'
                className='fontcool col-sm-2 col-form-label'
              >
                Email:
              </label>
              <div className='col-sm-10'>
                <input
                  type='text'
                  className='form-control simplefont'
                  id='staticEmail'
                  name='email'
                  onChange={onChange}
                  value={comment.email}
                  required
                />{" "}
              </div>
            </div>

            <div className='form-group simplefont col-form-label'>
              <label
                htmlFor='exampleFormControlTextarea1 '
                className='fontcool'
              >
                Comment
              </label>
              <textarea
                className='form-control simplefont'
                id='exampleFormControlTextarea1'
                onChange={onChange}
                value={comment.text}
                name='text'
                rows='3'
              ></textarea>
            </div>

            <button
              type='submit'
              className='btn btn-dark simplefont'
              onClick={onSend}
            >
              Send
            </button>
          </form>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
